import { GroupFeedType } from '@ms/yammer-graphql';

import { Entity, Feed, FeedType, Group, RealtimeSubscriptionType, YammerState } from '../../state/types';
import { getId, inboxAllFeedId, inboxDirectFeedId, inboxUnreadFeedId } from '../feeds/getId';

type GetSubscriptionCount = (
  state: YammerState,
  subscriptionType: RealtimeSubscriptionType,
  entityId: Entity['id']
) => number;
export const getSubscriptionCount: GetSubscriptionCount = (state, subscriptionType, entityId) => {
  const subscription = state.realtimeSubscriptions[subscriptionType][entityId];

  return subscription ? subscription.count : 0;
};

type IsGroupFeedSubscribed = (state: YammerState, groupId: Group['id']) => boolean;
export const isGroupFeedSubscribed: IsGroupFeedSubscribed = (state, groupId) => {
  const allId = getId({ type: FeedType.Group, subtype: GroupFeedType.ALL, entityId: groupId });
  if (getSubscriptionCount(state, RealtimeSubscriptionType.Feed, allId) > 0) {
    return true;
  }

  const questionsId = getId({ type: FeedType.Group, subtype: GroupFeedType.QUESTIONS, entityId: groupId });
  if (getSubscriptionCount(state, RealtimeSubscriptionType.Feed, questionsId) > 0) {
    return true;
  }

  const unansweredQuestionsId = getId({
    type: FeedType.Group,
    subtype: GroupFeedType.UNANSWERED_QUESTIONS,
    entityId: groupId,
  });
  if (getSubscriptionCount(state, RealtimeSubscriptionType.Feed, unansweredQuestionsId) > 0) {
    return true;
  }

  const unseenId = getId({ type: FeedType.Group, subtype: GroupFeedType.UNSEEN, entityId: groupId });
  if (getSubscriptionCount(state, RealtimeSubscriptionType.Feed, unseenId) > 0) {
    return true;
  }

  return false;
};

type IsInboxFeedSubscribed = (state: YammerState) => boolean;
export const isInboxFeedSubscribed: IsInboxFeedSubscribed = (state) => {
  if (getSubscriptionCount(state, RealtimeSubscriptionType.Feed, inboxAllFeedId) > 0) {
    return true;
  }

  if (getSubscriptionCount(state, RealtimeSubscriptionType.Feed, inboxDirectFeedId) > 0) {
    return true;
  }

  if (getSubscriptionCount(state, RealtimeSubscriptionType.Feed, inboxUnreadFeedId) > 0) {
    return true;
  }

  return false;
};

type IsFeedSubscriptionPaused = (state: YammerState, feedId: Feed['id']) => boolean;
export const isFeedSubscriptionPaused: IsFeedSubscriptionPaused = (state, feedId) =>
  !!state.realtimeSubscriptions.PausedFeed[feedId];
